import { render, staticRenderFns } from "./global-message-user.html?vue&type=template&id=4e4658fe&"
import script from "./global-message-user.js?vue&type=script&lang=js&"
export * from "./global-message-user.js?vue&type=script&lang=js&"
import style0 from "./global-message-user.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports